module.exports = __webpack_public_path__ + "static/icons/elevation-forecast-img-top-f14659b1bc196fa775e350a3aead3191.svg";